import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import { multiformatAtom } from "../../multiformat/store/multiformat-atom";

export const contentTypeFamily = atomFamily((contentTypeName: string) =>
  atom((get) =>
    get(multiformatAtom)?.["content-types"]?.find((c) => c["Content Type"] === contentTypeName),
  ),
);
